const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'SOB',
  description: 'Share-Of-Business settings',
  sortOrder: 4,
  name: 'optimaSOB',
  documentKey: 'optima_sob',
  values: {
    optimaSOB: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Optima SOB',
      documentKey: 'optima_sob',
    },
    isSobBasedOnVehicleType: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'based on vehicle type',
      documentKey: 'is_sob_based_on_vehicle_type',
    },
  },
};
